import store from '@/state/store'

export default [
   {
      path: '/',
      name: 'home',
      meta: {
         authRequired: true,
         moduleName: 'Dashboard',
      },
      component: () => import('./views/dashboards/default'),
   },

   {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
         authRequired: true,
         moduleName: 'Dashboard',
      },
      component: () => import('./views/dashboards/default'),
   },
   {
      path: '/login',
      name: 'login',
      component: () => import('./views/account/login'),
      meta: {
         beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
               // Redirect to the home page instead
               next({ name: 'default' })
            } else {
               // Continue to the login page
               next()
            }
         },
      },
   },

   {
      path: '/logout',
      name: 'logout',
      meta: {
         authRequired: true,
         beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
               store.dispatch('auth/logOut')
            } else {
               store.dispatch('authfack/logout')
            }
            const authRequiredOnPreviousRoute = routeFrom.matched.some(
               (route) => route.push('/login')
            )
            // Navigate back to previous page, or home as a fallback
            next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
         },
      },
   },
   {
      path: '/404',
      name: '404',
      component: require('./views/utility/404').default,
   },
   // Redirect any unmatched routes to the 404 page. This may
   // require some server configuration to work in production:
   // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
   {
      path: '*',
      redirect: '404',
   },

   {
      path: '/specializations',
      name: 'specializations',
      meta: { authRequired: true },
      component: () => import('./views/specializations/specializations')
   },

   {
      path: '/clinics',
      name: 'clinics',
      meta: { authRequired: true },
      component: () => import('./views/clinics/clinics')
   },

   {
      path: '/patients',
      name: 'patients',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/patients')
   },

   {
      path: '/patients/add',
      name: 'patients.add',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/add-patient')
   },

   {
      path: '/patients/edit',
      name: 'patients.edit',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/edit-patient')
   },

   {
      path: '/patients/details',
      name: 'patients.details',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/patient-details')
   },

   {
      path: '/patients/records/:id?',
      name: 'patients.records',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/records')
   },
   {
      path: '/patients/members/:id',
      name: 'patients.members',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/members')
   },
   {
      path: '/patients/member/details/:id?',
      name: 'patients.member-details',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/member-details')
   },

   {
      path: '/patients/bookings/:id?',
      name: 'patients.bookings',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/bookings')
   },
   {
      path: '/patients/member/bookings/:id?',
      name: 'patients.member-bookings',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/member-bookings')
   },
   {
      path: '/patients/member/records/:id?',
      name: 'patients.member-records',
      meta: {
         authRequired: true,
         moduleName: 'Patients',
      },
      component: () => import('./views/patients/member-records')
   },
   {
      path: "/doctors/pending",
      name: "doctors.pending",
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/pending-doctors')
   },

   {
      path: "/doctors/pending/details/:id?",
      name: "doctors.pending.details",
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/pending-doctor-details')
   },

   {
      path: '/doctors',
      name: 'doctors',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/doctors')
   },

   {
      path: '/doctors/add',
      name: 'doctors.add',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/add-doctor')
   },

   {
      path: '/doctors/edit',
      name: 'doctors.edit',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/edit-doctor')
   },

   {
      path: '/doctors/details/:id?',
      name: 'doctors.details',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/doctor-details')
   },

   {
      path: '/doctors/schedules/:id?',
      name: 'doctors.schedules',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/schedules')
   },

   {
      path: '/doctors/schedules/changes/:id',
      name: 'doctors.schedule.changes',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/schedule-change')
   },

   {
      path: '/doctors/upcoming-schedules',
      name: 'doctors.upcoming',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/upcoming-schedules')
   },

   {
      path: '/doctors/payments',
      name: 'doctors.payments',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/payments')
   },

   {
      path: '/doctors/payments/details',
      name: 'doctors.payments.details',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/payment-details')
   },

   {
      path: '/doctors/bookings/:id?',
      name: 'doctors.bookings',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/bookings')
   },
   {
      path: '/doctors/sessions/:id',
      name: 'doctors.sessions',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/doctor-sessions')
   },
   {
      path: '/doctors/symptom-questions/:doctor_id',
      name: 'doctors.symptom.questions',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/symptom-questions')
   },
   {
      path: '/pharmacies',
      name: 'pharmacies',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/pharmacies')
   },
   {
      path: '/pharmacy/add',
      name: 'pharmacies.add',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/add-pharmacy')
   },
   {
      path: '/pharmacy/edit/:id',
      name: 'pharmacies.edit',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/edit-pharmacy')
   },
   {
      path: '/pharmacy/bookings/:id',
      name: 'pharmacies.bookings',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/bookings')
   },
   {
      path: '/pharmacy/booking/add',
      name: 'pharmacy-bookings.add',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/add-booking')
   },
   {
      path: '/pharmacy/details/:id',
      name: 'pharmacies.details',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/pharmacy-details')
   },
   {
      path: '/pharmacy/counters/:id',
      name: 'pharmacies.counters',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies'
      },
      component: () => import('./views/pharmacy/counters')
   },
   {
      path: '/:module/tvs/:id',
      name: 'module.tvs',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies',
      },
      component: () => import('./views/pharmacy/tvs')
   },
   {
      path: '/pharmacy/outsource-token-calls/:id',
      name: 'pharmacies.outsource-token-calls',
      meta: {
         authRequired: true,
         moduleName: 'Pharmacies',
         module: 'pharmacy',
      },
      component: () => import('./views/pharmacy/outsource-token-calls')
   },
   {
      path: '/labs/outsource-token-calls/:id',
      name: 'labs.outsource-token-calls',
      meta: {
         authRequired: true,
         moduleName: 'Labs',
         module: 'lab',
      },
      component: () => import('./views/pharmacy/outsource-token-calls')
   },
   {
      path: '/doctors/tokens',
      name: 'doctors.tokens',
      meta: {
         authRequired: true,
         moduleName: 'Token Management',
      },
      component: () => import('./views/doctors/token')
   },
   {
      path: '/doctors/token/manage',
      name: 'doctors.tokens.manage',
      meta: {
         authRequired: true,
         moduleName: 'Token Management',
      },
      component: () => import('./views/doctors/token-details')
   },
   {
      path: '/doctors/token/manage2',
      name: 'doctors.tokens.manage2',
      meta: {
         authRequired: true,
         moduleName: 'Doctors',
      },
      component: () => import('./views/doctors/token-details2')
   },
   {
      path: '/doctors/token/symptoms/:id?',
      name: 'doctors.tokens.symptoms',
      meta: {
         authRequired: true,
         moduleName: 'Token Management',
      },
      component: () => import('./views/doctors/symptoms')
   },
   {
      path: '/prescriptions',
      name: 'prescriptions',
      meta: {
         authRequired: true,
         moduleName: 'Prescriptions',
      },
      component: () => import('./views/prescriptions/prescriptions')
   },
   {
      path: '/prescription-details',
      name: 'prescriptions-details',
      meta: {
         authRequired: true,
         moduleName: 'Prescriptions',
      },
      component: () => import('./views/prescriptions/prescription-details')
   },

   {
      path: '/consultations',
      name: 'consultations',
      meta: {
         authRequired: true,
         moduleName: 'Consultations',
      },
      component: () => import('./views/consultations/consultations')
   },
   // {
   //    path: '/clinic/booking',
   //    name: 'clinic-bookings',
   //    meta: { authRequired: true },
   //    component: () => import('./views/consultations/consultations_copy')
   // },

   {
      path: '/consultations/add/:id?/:patient_id?',
      name: 'consultations.add',
      meta: {
         authRequired: true,
         moduleName: 'Consultations',
      },
      component: () => import('./views/consultations/add-consultation')
   },
   {
      path: '/consultations/reschedule/:id/:doctor_id/:patient_id/:type/:clinic_id?',
      name: 'consultations.reschedule',
      meta: {
         authRequired: true,
         moduleName: 'Consultations',

      },
      component: () => import('./views/consultations/reschedule')
   },

   {
      path: '/consultations/details/:id?',
      name: 'consultations.details',
      meta: {
         authRequired: true,
         moduleName: 'Consultations',
      },
      component: () => import('./views/consultations/consultation-details')
   },

   {
      path: "/pharmacy-orders",
      name: "pharmacy.orders",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/orders')
   },

   {
      path: "/pharmacy-orders/add",
      name: "pharmacy.orders.add",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/create-order')
   },

   {
      path: "/pharmacy-orders/reorder",
      name: "pharmacy.orders.reorder",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/reorder')
   },

   {
      path: "/pharmacy-orders/details",
      name: "pharmacy.orders.details",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/order-details')
   },

   {
      path: "/pharmacy-requests",
      name: "pharmacy.requests",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/requests')
   },

   {
      path: "/pharmacy-requests/details",
      name: "pharmacy.requests.details",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/request-details')
   },

   {
      path: '/labs',
      name: 'labs',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/labs')
   },

   {
      path: '/labs/details:id',
      name: 'labs.details',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/lab-details')
   },

   {
      path: '/labs/add',
      name: 'labs.add',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/add-lab')
   },

   {
      path: '/labs/edit:id',
      name: 'labs.edit',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/edit-lab')
   },

   {
      path: '/labs/bookings/:id/:type',
      name: 'labs.bookings',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/bookings')
   },

   {
      path: '/labs/bookings/details:id',
      name: 'labs.bookings.details',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/booking-details')
   },
   {
      path: '/labs/schedules:id',
      name: 'labs.schedules',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/schedule')
   },
   {
      path: '/labs/tests:id',
      name: 'labs.tests',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/tests')
   },

   {
      path: '/labs/counters:id',
      name: 'labs.counters',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/counters')
   },

   {  
      path: "/labs/bookings/add/:id/:type",
      name: "labs.bookings.add",
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/add-booking')
   },

   {
      path: '/tests',
      name: 'tests',
      meta: { 
         authRequired: true,
         moduleName: 'Labs', 
      },
      component: () => import('./views/labs/all-tests')
   },

   {
      path: '/languages',
      name: 'languages',
      meta: { authRequired: true },
      component: () => import('./views/languages/languages')
   },

   {
      path: '/sliders',
      name: 'sliders',
      meta: { authRequired: true },
      component: () => import('./views/sliders/sliders')
   },

   {
      path: '/coupons',
      name: 'coupons',
      meta: { authRequired: true },
      component: () => import('./views/coupons/coupons')
   },

   {
      path: '/delivery-staffs',
      name: 'deliverystaffs',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/delivery-staffs')
   },

   {
      path: '/delivery-staffs/add',
      name: 'deliverystaffs.add',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/add-delivery-staff')
   },

   {
      path: '/delivery-staffs/edit',
      name: 'deliverystaffs.edit',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/edit-delivery-staff')
   },

   {
      path: '/delivery-staffs/details',
      name: 'deliverystaffs.details',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/delivery-staff-details')
   },


   {
      path: '/marketing-staffs',
      name: 'marketingstaffs',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/marketing-staffs')
   },

   {
      path: '/marketing-staffs/add',
      name: 'marketingstaffs.add',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/add-marketing-staff')
   },

   {
      path: '/marketing-staffs/edit',
      name: 'marketingstaffs.edit',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/edit-marketing-staff')
   },

   {
      path: '/marketing-staffs/details',
      name: 'marketingstaffs.details',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/marketing-staff-details')
   },

   {
      path: '/marketing-staffs/referrals',
      name: 'marketingstaffs.referrals',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/referrals')
   },

   {
      path: '/clinics',
      name: 'clinics',
      meta: { authRequired: true },
      component: () => import('./views/clinics/clinics')
   },

   {
      path: '/clinics/add',
      name: 'clinics.add',
      meta: { authRequired: true },
      component: () => import('./views/clinics/add-clinic')
   },

   {
      path: '/clinics/edit',
      name: 'clinics.edit',
      meta: { authRequired: true },
      component: () => import('./views/clinics/edit-clinic')
   },

   {
      path: '/clinics/doctors',
      name: 'clinics.doctors',
      meta: { authRequired: true },
      component: () => import('./views/clinics/doctors')
   },

   {
      path: '/tvshows',
      name: 'tvshows',
      meta: {
         authRequired: true,
         moduleName: 'TV Shows',
      },
      component: () => import('./views/tvshows/tvshows')
   },

   {
      path: '/feedbacks',
      name: 'feedbacks',
      meta: { authRequired: true },
      component: () => import('./views/feedbacks/feedbacks')
   },

   {
      path: '/scroll-contents',
      name: 'scrollcontents',
      meta: {
         authRequired: true,
         moduleName: 'Scrolling Contents',
      },
      component: () => import('./views/scrolling-contents/scrolling-contents')
   },


   {
      path: '/faqs',
      name: 'faqs',
      meta: { authRequired: true },
      component: () => import('./views/faqs/faqs')
   },

   {
      path: '/notifications',
      name: 'notifications',
      meta: {
         authRequired: true,
         moduleName: 'Notifications',
      },
      component: () => import('./views/notifications/notifications')
   },


   {
      path: '/settings',
      name: 'settings',
      meta: {
         authRequired: true,
         moduleName: 'Settings',

      },
      component: () => import('./views/settings/settings')
   },
   {
      path: '/reports/patients',
      name: 'reports.patients',
      meta: {
         authRequired: true,
         moduleName: 'Reports',
      },
      component: () => import('./views/reports/patients')
   },

   {
      path: '/reports/consultations',
      name: 'reports.consultations',
      meta: {
         authRequired: true,
         moduleName: 'Reports',
      },
      component: () => import('./views/reports/consultations')
   },
   {
      path: '/reports/earnings',
      name: 'reports.earnings',
      meta: {
         authRequired: true,
         moduleName: 'Reports',
      },
      component: () => import('./views/reports/earnings')
   },

   {
      path: '/not-authorized',
      name: 'not-authorized',
      component: () => import('./views/NotAuthorized.vue'),
   },

   
]
